import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FiCode, FiEdit3, FiUserCheck } from 'react-icons/fi';
import WebsiteLayout from '../../../layout/website/WebsiteLayout';
import { TabBar } from '../newServers/NewServersStyle';
import { PageBanner } from '../talents/TalentsStyle';
import TalentsGridSection from '../talents/TalentsGridSection';

const PageWrapper = styled.div`
  padding-bottom: 40px;
`;

const Padded = styled.div`
  padding: 0 20px;

  @media (max-width: 480px) {
    padding: 0 12px;
  }
`;

const TABS = {
  programmer: { icon: <FiCode />, titleKey: 'website.programmers.title', subKey: 'website.programmers.subtitle', addPath: '/add-programmer' },
  designer: { icon: <FiEdit3 />, titleKey: 'website.designers.title', subKey: 'website.designers.subtitle', addPath: '/add-designer' },
  beta_tester: { icon: <FiUserCheck />, titleKey: 'website.beta_testers.title', subKey: 'website.beta_testers.subtitle', addPath: '/add-beta-tester' },
};

const ProgrammersAndDesigners = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(TABS[searchParams.get('tab')] ? searchParams.get('tab') : 'programmer');

  const changeTab = (tab) => {
    setActiveTab(tab);
    setSearchParams(tab === 'programmer' ? {} : { tab });
  };

  const current = TABS[activeTab];

  return (
    <WebsiteLayout>
      <PageWrapper>
        <Padded>
          <PageBanner>
            <div className="page-title">{current.icon} {t(current.titleKey)}</div>
            <div className="page-sub">{t(current.subKey)}</div>
          </PageBanner>
        </Padded>

        <TabBar>
          <button className={activeTab === 'programmer' ? 'active' : ''} onClick={() => changeTab('programmer')}>
            <FiCode /> {t('website.programmers.title')}
          </button>
          <button className={activeTab === 'designer' ? 'active' : ''} onClick={() => changeTab('designer')}>
            <FiEdit3 /> {t('website.designers.title')}
          </button>
          <button className={activeTab === 'beta_tester' ? 'active' : ''} onClick={() => changeTab('beta_tester')}>
            <FiUserCheck /> {t('website.beta_testers.title')}
          </button>
        </TabBar>

        <Padded style={{ paddingTop: 20 }}>
          <TalentsGridSection category={activeTab} addPath={current.addPath} />
        </Padded>
      </PageWrapper>
    </WebsiteLayout>
  );
};

export default ProgrammersAndDesigners;
